import { Messages } from '../../codegen/Localize';
import { ISiteSettingsForServerAdmin } from '../../settings/types/ISite';
import { IActionContext } from '../helpers/ActionContext';
import { SiteSettingsErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Sites } from '../resources/Sites';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ToasterService, ToastType } from './ToasterService';

export class SuspendSitesAction {

  public static $inject = ['ConfirmActionDialog', '$translate', 'Sites'];
  private toaster = ToasterService.instance;

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private Sites: Sites) { }

  public execute(sites: Set<ISiteSettingsForServerAdmin>, actionContext: IActionContext): ng.IPromise<IResult> {
    return this.ConfirmActionDialog.open({
      title: Messages.suspendSites(),
      bodyText: this.$translate.instant('confirmSuspendSites', {
        SITE_NAME: L10n.elideIfLong(sites.first().settings.name),
        ITEM_COUNT: sites.size()
      }, L10n.Interpolations.Count),
      actionName: this.$translate.instant('suspendButtonConfirm', {
        ITEM_COUNT: sites.size()
      }, L10n.Interpolations.Count),
      isDeleteAction: true,
      action: (dialogInstance: IConfirmActionDialogInstance) => {

        return this.Sites.suspend(sites.keys()).then((result: IResult) => {
          if (result.errors && result.errors.length) {
            if (result.errors.length === 1 && result.errors[0].code === SiteSettingsErrorCode.AttemptedToSuspendDefaultSite) {
              this.toaster.pop({ type: ToastType.Error, text: this.$translate.instant('siteSettingsFailedAttemptedToSuspendDefaultSite') });
              this.toaster.pop({
                type: ToastType.Info,
                text: this.$translate.instant('sitesSuspendSuccess', {
                  ITEM_COUNT: sites.size() - 1
                }, L10n.Interpolations.Count)
              });
            } else {
              dialogInstance.showErrorMessage(this.$translate.instant('sitesSuspendFailed'));
            }
          } else {
            this.toaster.pop({
              type: ToastType.Info,
              text: this.$translate.instant('sitesSuspendSuccess', {
                ITEM_COUNT: sites.size()
              }, L10n.Interpolations.Count)
            });
          }
          return result;
        });
      }
    }).result;
  }

}

Module.instance().service('SuspendSitesAction', SuspendSitesAction);
